import { camelCase } from 'lodash'

/**
 * 收敛被后端展开的品目报价记录
 * @param resRecord
 * @returns {*[]}
 */
const convergeCompareData = resRecord => {
  const materialOfferList = []
  resRecord.forEach(item => {
    if (item.itemId) {
      const offerItemIndex = materialOfferList.findIndex(
        offerItem => offerItem.itemId === item.itemId
      )
      if (offerItemIndex > -1) {
        // 如果已经存在,则更新
        const offerItem = materialOfferList[offerItemIndex]
        Object.keys(offerItem.offerValue).forEach(offerSupplierKey => {
          const key = camelCase(item.offerNameCode)
          offerItem.offerValue[offerSupplierKey][key] =
            item.offerValue[offerSupplierKey].value
        })
      } else {
        // 如果没有，则插入
        Object.values(item.offerValue).forEach(valueItem => {
          valueItem[item.offerNameCode] = valueItem.value
        })
        materialOfferList.push(item)
      }
    }
  })
  return materialOfferList
}

/**
 * 根据品目报价列表进行展开
 * @param materialOfferList
 * @param rowList
 * @returns {*[]}
 */
const divergeCompareData = (materialOfferList, rowList) => {
  const result = []
  materialOfferList.forEach(item => {
    rowList.forEach(row => {
      Object.values(item.offerValue).forEach(valueItem => {
        valueItem.value = valueItem[row.offerNameCode]
      })
      const rowItem = JSON.parse(
        JSON.stringify({
          ...item,
          offerName: row.offerName,
          offerNameCode: row.offerNameCode
        })
      )
      result.push(rowItem)
    })
  })
  return result
}

/**
 * 获取要展示的供应商响应行列表
 */
const getRowList = responseList => {
  const getRowConfig = (offerName, offerNameCode) => {
    return { offerName, offerNameCode }
  }
  // 含税价
  const offerRow = getRowConfig('含税价', 'offer')
  // 税率
  const rateRow = getRowConfig('税率', 'rate')
  // 未含税价
  const noRateOfferRow = getRowConfig('未含税价', 'noRateOffer')

  // 其余扩展字段
  const otherExpandRowList = responseList.map(item =>
    getRowConfig(item.columnName, item.defineCode)
  )

  // TODO: 目前只是普通询比的含税报价，后续补充不含税报价和五菱报价
  return [offerRow, rateRow, noRateOfferRow, otherExpandRowList]
}

/**
 * 采购清单比价相关功能
 */
const useMaterialCompare = () => {
  return {
    convergeCompareData,
    divergeCompareData,
    getRowList
  }
}

export default useMaterialCompare
